export default "__VITE_ASSET__CVwndlzr__"